import { motion } from "framer-motion";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const ComingSoonSection = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      navigate("/login");
    };

    // Trigger only once on first scroll
    window.addEventListener("wheel", handleScroll, { once: true });

    return () => {
      window.removeEventListener("wheel", handleScroll);
    };
  }, [navigate]);

  return (
    <section className="relative h-screen flex items-center justify-center bg-background overflow-hidden">
      
      {/* Background pattern */}
      <div className="absolute inset-0 bg-web-pattern opacity-30" />

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className="relative z-10 flex flex-col items-center text-center px-4"
      >
        {/* LOGO CONTAINER */}
        <motion.div
          initial={{ opacity: 0, scale: 0.85 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.2, duration: 0.6, ease: "easeOut" }}
          className="
            w-52 h-32 sm:w-64 sm:h-36
            rounded-3xl
            bg-black/40
            backdrop-blur
            border border-primary/30
            shadow-2xl
            flex items-center justify-center
            mb-10
          "
        >
          <img
            src="/images/logo.png"
            alt="Classic Laptop Mall Logo"
            className="w-full h-full object-contain p-4"
          />
        </motion.div>

        {/* TITLE */}
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold font-['Exo_2'] mb-4">
          <span className="text-foreground">Classic</span>{" "}
          <span className="text-primary">Laptop Mall</span>
        </h1>

        {/* SUBTEXT */}
        <p className="text-muted-foreground text-lg max-w-xl">
          Website launching soon. Scroll to explore.
        </p>

        {/* SCROLL INDICATOR */}
        <motion.div
          onClick={() => navigate("/login")}
          className="mt-10 text-primary tracking-widest text-sm cursor-pointer"
          animate={{ y: [0, 8, 0] }}
          transition={{ repeat: Infinity, duration: 1.5, ease: "easeInOut" }}
        >
          ↓ SCROLL ↓
        </motion.div>
      </motion.div>
    </section>
  );
};
